import axios from 'axios'
// import { ref } from 'vue'
// import { useCookies } from 'vue3-cookies'
// import Cookies from 'vue3-cookies';
// import { useRouter, useRoute } from 'vue-router'

// const router = useRouter()
// const route = useRoute()

const instance = axios.create({
  baseURL: process.env.VUE_APP_LMS_URL,
})

// const setBaseProtocol = window.location.protocol
const setBaseUrl = window.location.origin

// const setBaseUrl = window.location.href
// 현재 URL에서 쿼리 파라미터 제거한 기본 URL을 가져오는 함수
// const setBaseUrl = () => {
//   // 현재 경로와 쿼리 파라미터 확인하기
//   const baseUrl = `${window.location.protocol}//${window.location.host}${route.path}`
//   // 현재 기본 URL 출력
//   console.log('Base URL without Query Params:', baseUrl)
//   // 쿼리 파라미터를 제거하고 URL 변경
//   router.push({ path: route.path })
//   return baseUrl
// }

// const civsBaseUrl = process.env.VUE_APP_HOST_URL

// eslint-disable-next-line import/prefer-default-export
export async function joinWithOacx() {
  try {
    const joinType = 'OACX'
    const data = { token: localStorage.getItem('sid') }
    const headers = { 'Content-Type': 'application/json' }
    const joinOacxRes = await instance.post(
      `/api/v1/member/auth/join/identification/${joinType}`,
      data,
      headers
    )
    if (joinOacxRes.data.content) {
      localStorage.setItem('idfc_id', joinOacxRes.data.content.idfc_id)
      localStorage.setItem('name', joinOacxRes.data.content.name)
      localStorage.setItem('birth', joinOacxRes.data.content.birth)
      localStorage.setItem('phone', joinOacxRes.data.content.phone)
    }
    return joinOacxRes.data
  } catch (err) {
    return err.response.data
  }
}

export async function loadCivsPopup() {
  // alert(setBaseUrl)
  const data = { return_url: `${setBaseUrl}/civs_result` }
  // const data = { return_url: `${setBaseProtocol}${setBaseUrl}/civs_result` }
  // const data = { return_url: `${civsBaseUrl}/civs_result` }
  // const data = { return_url: `${civsBaseUrl}/civs` }
  const headers = { 'Content-Type': 'application/json' }
  const civsRes = await instance.post(
    `/api/v1/member/auth/civs/popup`,
    data,
    headers
  )
  return civsRes.data
}

// eslint-disable-next-line consistent-return
export async function joinWithCivs() {
  try {
    const joinType = 'CIVS'
    const data = { token: localStorage.getItem('sid') }
    const headers = { 'Content-Type': 'application/json' }
    const joinCivsRes = await instance.post(
      `/api/v1/member/auth/join/identification/${joinType}`,
      data,
      headers
    )
    console.log('정상진입')
    console.log('joinCivsRes ::: ', joinCivsRes)
    if (joinCivsRes.data.content) {
      localStorage.setItem('idfc_id', joinCivsRes.data.content.idfc_id)
      localStorage.setItem('name', joinCivsRes.data.content.name)
      localStorage.setItem('birth', joinCivsRes.data.content.birth)
      localStorage.setItem('phone', joinCivsRes.data.content.phone)
    }
    return joinCivsRes.data
  } catch (err) {
    return err.response.data
  }
}

// export async function sendDataCivsCallback() {
//   const callbackRes = await instance.post(`/api/v1/member/auth/civs/callback`)
// }

export async function checkDuplicationID(enterID) {
  try {
    // console.log(enterID)
    const checkRes = await instance.get(
      `/api/v1/member/auth/join/exists?userId=${enterID}`
    )
    return checkRes.data
  } catch (err) {
    return err.response.data
  }
}

// eslint-disable-next-line consistent-return
export async function saveNewUserDatas(userData) {
  try {
    // console.log(userData)
    // console.log('userData 1')
    const joinType = localStorage.getItem('joinType')
    if (joinType === 'IDV') {
      // console.log('userData 2')
      const headers = { 'Content-Type': 'application/json' }
      const initDataRes = await instance.post(
        `/api/v1/member/auth/join/${joinType}`,
        userData,
        headers
      )
      // console.log('userData 3')
      // console.log('initDataRes :::', initDataRes)
      // console.log('initDataRes.data :::', initDataRes.data)
      // console.log('userData 4')
      return initDataRes.data
    }
    // console.log('유저 정보 삽입 함수 진입')
  } catch (err) {
    // console.log('userData 55')
    // console.log(err)
    // console.log('err.response.data   ::: ', err.response.data)
    // console.log('userData 666')
    return err.response.data
  }
}
